<template>
  <div>
    <ul>
      <origin-list-item
        v-for="(card, index) in cCards"
        v-bind:key="`oli-${index}`"
        :isWinner="card === winner"
        :isLoser="card === loser"
        :class="{finished: !editing}"
        @click.native="click(card.url)"
      >
        <div slot="left" v-if="editing">{{index | playerForIndex}}</div>
        <div v-else slot="left">{{card.keyword}}</div>
        <input
          v-if="editing"
          type="text"
          slot="right"
          placeholder="ENTER CARD#"
          class="enterCard"
          v-model="card.id"
          style="height:100%;"
        />
        <div v-else slot="right">{{displayDate(card)}}</div>
      </origin-list-item>
    </ul>
    <button @click="addCard" class="addPlayer" v-if="editing">+ ADD CARD</button>
  </div>
</template>

<script>
  import OriginListItem from '@/components/OriginListItem'
  import { mapActions, mapMutations } from 'vuex'

  export default {
    name: 'origin-list',
    components: {
      OriginListItem: OriginListItem
    },
    data: function() {
      return {
        months: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ]
      }
    },
    props: {
      cards: Array,
      editing: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      cCards: function() {
        return this.cards.map(card => {
          if (card.id) {
            card.id = card.id.toUpperCase()
          }
          return card
        })
      },
      winner: function() {
        if (!this.editing) return this.cards[1]
      },
      loser: function() {
        if (!this.editing) return this.cards[this.cards.length - 1]
      }
    },
    filters: {
      playerForIndex: function(v) {
        if (v == 0) return 'ORIGIN:'
        else {
          return `CARD ${v + 1}:`
        }
      }
    },
    methods: {
      ...mapMutations({ addCard: 'ADD_CARD' }),
      formatYear: function(year) {
        if (!year) return ''
        else {
          if (year < 0) {
            return `${year * -1} BC`
          }
          return `${year}`
        }
      },
      displayDate: function(card) {
        if (!card) return ''
        else {
          let year = this.formatYear(card.year)
          let month = this.months[card.month - 1]
          let day = card.day
          if (month && day && year) {
            return `${month} ${day}, ${year}`
          } else if (month && year) {
            return `${month}, ${year}`
          } else {
            return `${year}`
          }
        }
      },
      click(url) {
        if (!url) return
        window.open(url, '_blank')
      }
    }
  }
</script>

<style lang="less">
  .finished {
    cursor: pointer;
  }
  ul {
    list-style: none;
    background: #e8eeee;
    padding: 0;
    border-bottom: 0.3rem solid #cdd7d7;
  }
  .addPlayer {
    border: none;
    color: #424848;
    background: #dddddd;
    font-size: 1.2rem;
    font-weight: bold;
    margin-left: 2rem;
    padding: 1.1rem;
    margin-bottom: 2rem;
    cursor: pointer;
  }
  .enterCard {
    background: #e8eeee;
    border: none;
    color: #a0abab;
    font-weight: bold;
    font-size: 1.2rem;
    text-align: right;
  }
  .enterCard::placeholder {
    color: #a0abab;
  }
</style>
